module.exports = __webpack_public_path__ + "images/images/logo_ppa-1c755af25916c3f9a746997ea8451e86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_ppa.svg
// module id = 453
// module chunks = 2